import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AcubePaymentsPage } from '@/pages/acube-payments';
import { acubePaymentsSearchSchema } from '@/routes/-shared/acubePaymentsSearchSchema';

/**
 * La lista resta montata e il dettaglio si apre sopra di lei sull'`Outlet`
 * (`$id` per una riga del registro ACube, `sepa/$id` per un bonifico senza
 * registro), come nella webapp: chiuderlo torna alla lista con i filtri di
 * prima, e il link al pagamento si può condividere.
 */
export const Route = createFileRoute('/admin/_layout/acube-payments/_layout')({
  component: AcubePaymentsLayout,
  validateSearch: acubePaymentsSearchSchema,
});

function AcubePaymentsLayout() {
  return (
    <>
      <AcubePaymentsPage />
      <Outlet />
    </>
  );
}
